import { uk, type Strings } from './uk'

/// The panel's strings. Ukrainian only for now; Russian will be a second
/// `Strings` object chosen here.
export const t: Strings = uk

export { plural } from './uk'

const dateFormat = new Intl.DateTimeFormat('uk-UA', { day: 'numeric', month: 'short', year: 'numeric' })

/// «23 жовт. 2026 р.» → «23 жовт. 2026» — the trailing «р.» is noise in a list.
export const formatDate = (iso: string): string =>
  dateFormat.format(new Date(iso)).replace(/\s*р\.$/, '')
